var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 1.96964L6.63205 4.99989L9.662 8.03C10.1127 8.48086 10.1127 9.2112 9.662 9.66206C9.43681 9.88724 9.14157 9.99992 8.84648 9.99992C8.5509 9.99992 8.25564 9.88741 8.03063 9.66206L5.00002 6.6316L1.96965 9.66203C1.74449 9.88721 1.44922 9.99989 1.15387 9.99989C0.858611 9.99989 0.563548 9.88739 0.338189 9.66203C-0.1125 9.21137 -0.1125 8.48101 0.338189 8.02997L3.36805 4.99986L0.338017 1.96964C-0.112672 1.51895 -0.112672 0.788446 0.338017 0.337758C0.78862 -0.112586 1.5187 -0.112586 1.96947 0.337758L4.99999 3.36801L8.03028 0.337758C8.48114 -0.112586 9.21131 -0.112586 9.66182 0.337758C10.1127 0.788446 10.1127 1.51895 9.662 1.96964Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0a73c451.svg";
export { ForwardRef as ReactComponent };